<template>
    <div class="BclassName">
        <div class="dataScreen_content_top_left_top">
            <div class="dataScreen_content_top_left_top_left">
                <img src="../../assets/img/imgStaly1/class_icon1.png" class="dataScreen_content_top_left_top_img" alt="">
                <span class="dataScreen_content_top_left_top_left_span">{{bclassInfo.gradeAndBClassName}}</span>
            </div>
            <div class="dataScreen_content_top_left_top_right">
                <img src="../../assets/img/imgStaly1/teacher_icon2.png" style="width: 28px;" class="dataScreen_content_top_left_top_img" alt="">
                <span>班主任： {{bclassInfo.teacherName}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {getBulletinBoardContent} from '@/api/other'
    // import vueSeamlessScroll from 'vue-seamless-scroll'
    export default {
        name: "BclassName",
        props: {
            record: {
                type: Object
            },
            currentSubSchoolId: {
                type: String
            },
            bclassId: {
                type: String
            }
        },
        components: {
            // vueSeamlessScroll
        },
        // 监听属性 类似于data概念      
        computed: {
            defaultOption() {
                return {
                    step: this.record.step ? this.record.step : 1, // 数值越大速度滚动越快   
                    limitMoveNum: this.record.limitMoveNum ? this.record.limitMoveNum : 6, // 开始无缝滚动的数据量 this.dataList.length              
                    hoverStop: false, // 是否开启鼠标悬停stop          
                    direction: 1, // 0向下 1向上 2向左 3向右      
                    openWatch: true, // 开启数据实时监控刷新dom                
                    singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1             
                    singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3      
                    waitTime: 1000 // 单步运动停止的时间(默认值1000ms)            
                }
            }
        },
        data() {
            return {
                bclassInfo: {}
            };
        },
        methods: {
            //  优秀表现 
            getGoodKeshi() {
                const data = {}
                data.id = this.bclassId
                getBulletinBoardContent(data,
                    (resp) => {
                        const data = resp.data
                        this.bclassInfo = data
                    },
                    (err) => {
                        this.$message.error(err)
                    }
                )
            },
        },
        mounted() {
            this.getGoodKeshi()
        }
    }
</script>

<style scoped>
    @import '../../assets/css/electronicClassBoard.css';
</style>